import * as React from 'react';
import { FunctionComponent } from 'react';
import { QUESTIONS_TEMPLATE_TYPE } from 'Src/consts/message';
import { Report } from '../../models/report';

interface Props {
  consent: Report;
}

export const ConsentRequestTemplate: FunctionComponent<Props> = props => {
  const { consent } = props;
  const fields = consent.fields || [];

  const rows = fields.map((field, index) => {
    const { heading, value, type } = field;
    const isExistValue = typeof value !== 'undefined';

    let valueConverted;

    switch (type) {
      case QUESTIONS_TEMPLATE_TYPE.NUMBER:
      case QUESTIONS_TEMPLATE_TYPE.STRING:
      case QUESTIONS_TEMPLATE_TYPE.ENUM:
        valueConverted = value;
        break;
      case QUESTIONS_TEMPLATE_TYPE.BOOLEAN:
        if (isExistValue) {
          if (typeof value === 'boolean') {
            valueConverted = value ? 'Yes' : 'No';
          } else {
            valueConverted = value === 'true' ? 'Yes' : 'No';
          }
        } else {
          valueConverted = '';
        }
        break;
    }

    return (
      <tr key={`parental_consent_request_${index}`}>
        <td>
          <div className="d-flex flex-column">
            <div className="">{heading}</div>
            <div className="font-weight-bold">{valueConverted}</div>
          </div>
        </td>
      </tr>
    );
  });

  return (
    <table className={'table table-sm mPre'}>
      <tbody>{rows}</tbody>
    </table>
  );
};

ConsentRequestTemplate.displayName = 'ConsentRequestTemplate';
